import React from 'react';
import {
  TextInput,
  Form,
  Button,
  InlineLoading,
  Dropdown
} from 'carbon-components-react';
import { FormError } from 'components';
import { ToastNotification } from 'carbon-components-react';
import { removeErrors } from 'redux/members/actions';
import { useDispatch, useSelector } from 'react-redux';
import { setAdminUserModelOpenStart } from 'redux/organisation/action';
import { currentUser } from 'redux/session/selectors';
const AddUserForm: React.FC<any> = ({
  formik,
  errorMessage,
  isSubmitting,
  isSuccess
}: any) => {
  const dispatch = useDispatch();
  const {
    Organisation: { role: orgRole }
  } = useSelector(currentUser);
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    setFieldValue
  } = formik;

  const isAddEnabled =
    values.firstName &&
    values.lastName &&
    values.emailAddress &&
    values.role &&
    !errors.firstName &&
    !errors.lastName &&
    !errors.emailAddress &&
    !errors.role;

  const handleCancel = () => {
    dispatch(setAdminUserModelOpenStart(false));
    dispatch(removeErrors());
  };

  const roleListItem = [
    {
      value: 'AOADMIN',
      label: 'Administrator'
    },
    {
      value: 'AOVIEWER',
      label: 'Viewer'
    }
  ];

  return (
    <Form
      className="add-adminstrator-form"
      data-testid="add-adminstrator-form"
      onSubmit={handleSubmit}
    >
      <section className="add-user-form-item">
        <h1 className="administrator-form-main-heading">
          Add {orgRole !== 'ASSETOWNER' ? 'administrator' : 'user'}
        </h1>
      </section>
      {errorMessage && (
        <section className="add-user-form-item">
          <ToastNotification
            lowContrast
            caption=""
            iconDescription="describes the close button"
            subtitle={errorMessage}
            timeout={0}
            title="Add user error"
            onCloseButtonClick={() => dispatch(removeErrors())}
          />
        </section>
      )}
      <section className="add-user-form-item">
        <TextInput
          id="firstName"
          name="firstName"
          labelText="First name"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.firstName}
          data-testid="firstName"
        />
        {touched.firstName && errors.firstName ? (
          <FormError>{errors.firstName}</FormError>
        ) : null}
      </section>
      <section className="add-user-form-item">
        <TextInput
          id="lastName"
          name="lastName"
          labelText="Last name"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.lastName}
          data-testid="lastName"
        />
        {touched.lastName && errors.lastName ? (
          <FormError>{errors.lastName}</FormError>
        ) : null}
      </section>

      <section className="add-user-form-item">
        <TextInput
          id="emailAddress"
          name="emailAddress"
          labelText="Email address"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.emailAddress}
          data-testid="emailAddress"
          helperText="An email will notify them of their new role"
        />
        {touched.emailAddress && errors.emailAddress ? (
          <FormError>{errors.emailAddress}</FormError>
        ) : null}
      </section>

      {orgRole === 'ASSETOWNER' && (
        <section className="add-user-form-item">
          <Dropdown
            id="role"
            titleText="Role"
            label="Choose an option"
            items={roleListItem}
            itemToString={(item: any) => item.label}
            onBlur={handleBlur}
            onChange={(item: any) =>
              setFieldValue('role', item?.selectedItem?.value)
            }
          />
          {errors.role && touched.role && <FormError>{errors.role}</FormError>}
        </section>
      )}

      <section className="add-user-form-item">
        <div className="button-set">
          <Button
            id="cancel"
            name="cancel"
            kind="secondary"
            data-testid="cancel"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            id="create"
            name="create"
            type="submit"
            kind="primary"
            data-testid="submit"
            size="sm"
            disabled={!isAddEnabled || isSubmitting || isSuccess}
          >
            {(!isSubmitting || errorMessage) && !isSuccess ? (
              `Save`
            ) : (
              <InlineLoading
                description={isSuccess ? 'Saved' : 'Saving ...'}
                status={isSuccess ? 'finished' : 'active'}
                aria-live={'assertive'}
              />
            )}
          </Button>
        </div>
      </section>
    </Form>
  );
};

AddUserForm.displayName = 'AddUserForm';
export default AddUserForm;
